/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2024-05-22 17:53:42
 *
 *******************************************************/
//@flow

import _ from 'lodash';

import React, { Component } from 'react';
import { Card, Heading, SkeletonPage, Layout, SkeletonBodyText } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { connect } from 'react-redux';
import { Carousel } from 'src/components/views/common/carousel';
import history from 'src/routes/history';
import { routes } from 'src/routes';

import BadgeAIIcon from 'src/assets/images/dashboard-v3/badge-ai.svg';
import { CROSS_SELL_UP_SELL } from 'src/constants/homepage';
import {
  DEFAULT_MAPPING_UPSELL,
  DATA_UPSELL,
  DATA_UPSELL_ITEM_STORE,
  FEATURES,
  FeaturesKYC
} from 'src/constants/dashboard-v4';
import { getPackageTypeByPlanId } from 'src/helpers/dashboard-helper';

class CrossSellUpSell extends Component<WithI18nProps> {
  render() {
    const { i18n, tenantApp, useBoltOn } = this.props;
    const { selectedPlan = '', kycData } = tenantApp;

    if (useBoltOn) return <></>;

    const packageName = getPackageTypeByPlanId(selectedPlan.replace('_discount', ''));
    const kycFeature = kycData?.features?.length ? kycData?.features : Object.keys(FeaturesKYC);
    const features = [
      ...DEFAULT_MAPPING_UPSELL[`${kycFeature.sort().join('+')}_${packageName}`],
      DATA_UPSELL_ITEM_STORE
    ];

    let elements = [];
    if (!features || !features.length) {
      elements = this.defaultSkeletonElements();
    } else {
      elements = this.buildCSUSElements(i18n, features);
    }

    return (
      <div className="BC-CrossSellUpSell__DashboardV3 V4">
        <Heading>{i18n.translate('AdminHTML.DashboardV3.CrossSellUpSell.title')}</Heading>
        <div className="feature-list">
          <Carousel items={elements} autoDisplay={true} timeInterval={5000} />
        </div>
      </div>
    );
  }

  goToFeaturePage = (name, type) => {
    if (type === 'add-on') {
      history.push(routes.subscription.addon(), {
        addOnName: CROSS_SELL_UP_SELL.addon[name],
        analyticDays: CROSS_SELL_UP_SELL.addon[name] === 'analytics' ? name.split('-')[1] : ''
      });
    }
    switch (name) {
      case 'store':
        history.push(routes.subscription.addon());
        return;
      case FEATURES.ANALYTICS:
        history.push(routes.analytics.appImpact());
        return;
      case FEATURES.MERCHANDISING:
        history.push(routes.merchandising.view());
        return;
      case FEATURES.RECOMMENDATION:
        history.push(routes.recommendationWidgets.list());
        return;
      case FEATURES.SWATCH_SETTINGS:
        history.push(routes.swatchSettings.view());
        return;
      case FEATURES.INSTANT_SEARCH_DISPLAY:
        history.push(routes.instantSearchWidget.view());
        return;
      case FEATURES.AI_SYNONYMS:
        history.push(routes.synonym.view(), { tab: 1 });
        return;
      case FEATURES.MANAGE_FILTER_TREE:
        history.push(routes.filterSettings.view());
        return;
      default:
        return;
    }
  };

  defaultSkeletonElements = () => {
    const elements = [];
    for (let index = 0; index < 2; index++) {
      elements.push(
        <div className={`card card-feature`}>
          <SkeletonPage primaryAction fullWidth>
            <Layout>
              <Layout.Section oneHalf={true}>
                <Card sectioned>
                  <SkeletonBodyText lines={4} />
                </Card>
              </Layout.Section>
            </Layout>
          </SkeletonPage>
        </div>
      );
    }

    return elements;
  };

  buildCSUSElements = (i18n: any, features: any) => {
    const elements = features.map(feature => {
      const { name: featureName, type: featureType } = feature;
      const data = featureName === 'store' ? feature : DATA_UPSELL[featureName];
      const { icon, title, label, btn, isHasAI } = data;

      return (
        <div className={`card ${featureName}`}>
          <div className="head">
            <div className="icon">
              <img src={icon} alt="ai" />
            </div>
            <span>{i18n.translate(title)}</span>
            {isHasAI && <img src={BadgeAIIcon} alt="ai" />}
          </div>
          <div className="label">{i18n.translate(label)}</div>
          <span className="btn" onClick={() => this.goToFeaturePage(featureName, featureType)}>
            {i18n.translate(btn)}
          </span>
        </div>
      );
    });

    return elements;
  };
}

const mapStateToProps = (state, props) => {
  return {
    tenantApp: _.get(state.oauth, 'tenantApp', {}),
    notAllowAddon: _.get(state.oauth, 'subscription.notAllowAddon', false),
    useBoltOn: _.get(state.oauth, 'subscription.useBoltOn', false)
  };
};

export default connect(mapStateToProps, null)(withI18n()(CrossSellUpSell));
